module.exports = __webpack_public_path__ + "img/qr_code_icon.4495ca2a.svg";